import TransactionService from '../../../service/TransactionService';
import {
  PARTIAL_REFUND, STANDARD_REFUND, FULL_REFUND, MONEY_REFUND, REFUND_SERVICE_REFUND,
} from './Constants';

import { V2, V3, POS, } from '../../../modules/Constants';

function Builder() {
  let version;
  let refundType;
  let refundMethod;
  let payload;
  let isPOS;

  this.version = (versionParam) => {
    version = versionParam;
    return this;
  };

  this.payload = (data) => {
    payload = data;
    return this;
  };

  this.refundType = (refundTypeParam) => {
    refundType = refundTypeParam;
    return this;
  };

  this.refundMethod = (refundMethodParam) => {
    refundMethod = refundMethodParam;
    return this;
  };

  this.isPos = (isPOSParam) => {
    isPOS = isPOSParam;
    return this;
  };

  this.build = () => {
    const options = isPOS ? getOptions()[POS] : getOptions()[version];
    return {
      getVersion: () => version,
      getRefundType: () => refundType,
      getRefundMethod: () => refundMethod,
      getPayload: () => ({ ...payload, }),
      getPOS: () => isPOS,
      refund: () => {
        if (refundType === FULL_REFUND && refundMethod === STANDARD_REFUND) {
          return options.fullRefund.billRefund(payload);
        }
        if (refundType === PARTIAL_REFUND && refundMethod === STANDARD_REFUND) {
          return options.partialRefund.billRefund(payload);
        }

        if (refundType === FULL_REFUND && refundMethod === MONEY_REFUND) {
          return options.fullRefund.moneyOnly(payload);
        }

        if (refundType === PARTIAL_REFUND && refundMethod === MONEY_REFUND) {
          return options.partialRefund.moneyOnly(payload);
        }

        if (refundType === PARTIAL_REFUND && refundMethod === REFUND_SERVICE_REFUND) {
          return options.partialRefund.refundServiceRefund(payload);
        }

        throw Error(`Unsupported refund configuration ${JSON.stringify(this)}`);
      },
    };
  };

  const getOptions = () => {
    const version2 = {
      fullRefund: {
        moneyOnly: transaction => TransactionService.v2FullRefundMoney(transaction.id),
        billRefund: (transaction) => {
          const transactionId = transaction.id;
          return TransactionService.fullBillRefund({ transactionId, });
        },
      },
      partialRefund: {
        moneyOnly: (data) => {
          const { transactionId, } = data;
          return TransactionService.v2PartialRefundMoney(transactionId, data.refundRequest);
        },
        billRefund: data => TransactionService.partialBillRefund(data),
      },
    };
    const version3 = {
      fullRefund: {
        moneyOnly: transaction => TransactionService.v3FullRefundMoney(transaction.id),
        billRefund: transaction => TransactionService.v3Refund({
          transactionId: transaction.id,
          lineItems: [],
          fees: {},
        }),
      },
      partialRefund: {
        moneyOnly: data => TransactionService.v3PartialRefundMoney(data.transactionId, {
          lineItems: data.lineItems,
          fees: data.fees,
        }),
        billRefund: data => TransactionService.v3Refund({
          transactionId: data.transactionId,
          lineItems: data.lineItems,
          fees: data.fees,
        }),
        refundServiceRefund: data => TransactionService.v3RefundServiceRefund({
          transactionId: data.transactionId,
          lineItems: data.lineItems?.map(lineItem => {
            return {
              amount: lineItem.amount,
              lineItemId: lineItem._id,
            };
          }),
          reason: data.reason,
          note: data.note,
          initiatorType: data.initiatorType,
        }),
      },
    };
    const Pos = {
      fullRefund: {
        billRefund: transaction => TransactionService.refundPOSTransaction({
          transactionId: transaction.id,
          tenantId: transaction.tenantId,
          lineItems: transaction.lineItems,
          externalId: transaction.externalId,
        }),
      },
    };

    const options = {};
    options[V2] = version2;
    options[V3] = version3;
    options[POS] = Pos;
    return options;
  };

  return this;
}

export default Builder;
